module.exports = __webpack_public_path__ + "static/media/marker.e5e93ccb.svg";